module.exports = __webpack_public_path__ + "img/answer-c1-2.dc60d3c4.png";